import { createReduxWrapper } from '@doda/common/src/redux/utils/createReduxWrapper';
import { BasicLayout } from 'components/layouts/BasicLayout';
import { FC } from 'react';
import { Provider } from 'react-redux';
import { HEADER_NAV_MENU } from '@doda/pc/src/constants/headerNavMenu';
import { reducer } from '@doda/pc/src/redux/store';
import { initServerSideProps } from './initServerSideProps';
import {
  FeaturedJobListScreen,
  FeaturedJobListScreenProps,
} from './screens/FeaturedJobListScreen';

/**
 * FeatureJobListページのProps
 */
export interface FeatureJobListPageProps {
  pageProps: FeaturedJobListScreenProps;
}

const FeatureJobList: FC<FeatureJobListPageProps> = (pageProps) => {
  const { store, props } = wrapper.useWrappedStore(pageProps);
  const {
    topicJob,
    isNoPic,
    jobList,
    jobListMeta,
    currentPage,
    featuredId,
    initialSideBarMasterData,
    initialJobCountData,
    modalMasterData,
    featuredSearchCondition,
    validationMessages,
  } = props.pageProps;

  return (
    <Provider store={store}>
      <BasicLayout selectedNavItem={HEADER_NAV_MENU.SEARCH}>
        <FeaturedJobListScreen
          topicJob={topicJob}
          isNoPic={isNoPic}
          jobList={jobList}
          jobListMeta={jobListMeta}
          currentPage={currentPage}
          featuredId={featuredId}
          initialSideBarMasterData={initialSideBarMasterData}
          initialJobCountData={initialJobCountData}
          modalMasterData={modalMasterData}
          featuredSearchCondition={featuredSearchCondition}
          validationMessages={validationMessages}
        />
      </BasicLayout>
    </Provider>
  );
};

const wrapper = createReduxWrapper(reducer);

export const getServerSideProps =
  wrapper.getServerSideProps(initServerSideProps);

export default FeatureJobList;
